export default __webpack_public_path__ + "static/media/loading.9c603e23.gif";